var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#A7B9F5",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6719 15.547H18.4648M20.3123 20.4548H7.44159C7.19901 20.4548 7.00214 20.2562 7.00214 20.0153V10.0239C7.00214 9.78135 7.20077 9.58447 7.44159 9.58447H20.3141C20.5566 9.58447 20.7535 9.78311 20.7535 10.0239V20.0153C20.7517 20.2562 20.5549 20.4548 20.3123 20.4548V20.4548ZM12.9805 12.9823H14.7734H12.9805ZM9.28905 12.9823H11.082H9.28905ZM16.6719 12.9823H18.4648H16.6719ZM12.9805 18.1099H14.7734H12.9805ZM9.28905 18.1099H11.082H9.28905ZM10.3613 11.0241V7.61572V11.0241ZM17.3926 11.0241V7.61572V11.0241ZM12.9805 15.547H14.7734H12.9805ZM9.28905 15.547H11.082H9.28905Z",
    stroke: "#435BAA",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.f7f9c6097790f87bdd50b474b2aeb5db.svg";
export { ForwardRef as ReactComponent };